import eDeliveryInlineViewTemplate from "./EDeliveryInlineViewTemplate";

var EDeliveryInlineDirective = function () {
    return {
        restrict: "E",
        controller: "EDeliveryInlineController",
        controllerAs: "ctrl",
        template: eDeliveryInlineViewTemplate
    };
};

export default EDeliveryInlineDirective;
